import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Sigma } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}`);
      navigate(loc.state?.from || "/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-5 py-12" data-testid="login-page">
      <div className="mb-8 flex items-center gap-2">
        <Sigma className="h-6 w-6 text-[#E61A27]" />
        <h1 className="font-display text-3xl text-slate-900">Sign in</h1>
      </div>
      <form onSubmit={submit} className="axiom-card space-y-4 p-7">
        <div>
          <label className="eyebrow">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]" />
        </div>
        <div>
          <label className="eyebrow">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]" />
        </div>
        <button data-testid="login-submit" disabled={loading} className="btn-crimson w-full">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-5 text-center text-sm text-slate-500">
        New to Axioms? <Link to="/register" className="text-[#D4AF37] hover:underline">Create an account</Link>
      </p>
      <div className="axiom-card mt-6 p-4 text-xs text-slate-500">
        Demo accounts (password <span className="font-mono text-slate-600">Password123!</span>): customer@axioms.dev ·
        contributor@axioms.dev · reviewer@axioms.dev · reviewer2@axioms.dev · adjudicator@axioms.dev
      </div>
    </div>
  );
}
